import { render, staticRenderFns } from "./DialogWithCloseButton.vue?vue&type=template&id=55d92d51&"
import script from "./DialogWithCloseButton.vue?vue&type=script&lang=ts&"
export * from "./DialogWithCloseButton.vue?vue&type=script&lang=ts&"
import style0 from "./DialogWithCloseButton.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DialogWithCloseButton.vue"
export default component.exports